export default "__VITE_ASSET__SoUJnduU__"